import { defineStore } from 'pinia'

export const EVENT_RSVP_STATUS = Object.freeze({
  NONE: 'NONE',
  TRIGGERED: 'TRIGGERED',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
})

export const useEventsStore = defineStore('events', {
  state: () => ({
    rsvpEventId: null,
    rsvpEventTitle: null,
    rsvpEventStatus: EVENT_RSVP_STATUS.NONE,
  }),
  persist: true,
  actions: {
    setRsvpToEvent(eventId, eventTitle, eventStatus) {
      this.rsvpEventId = eventId
      this.rsvpEventTitle = eventTitle
      this.rsvpEventStatus = eventStatus
    },
    setRsvpEventStatus(eventStatus) {
      this.rsvpEventStatus = eventStatus
    },
    clearRsvpEvent() {
      this.rsvpEventId = null
      this.rsvpEventTitle = null
      this.rsvpEventStatus = EVENT_RSVP_STATUS.NONE
    },
  },
})
